import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";

import FilterMenu from "../../components/filterMenu";
import SubscriptionTable from "./subscriptionTable";
import CustomPagination from "../../components/CustomPagination";
import { isValidInput } from "../../utils/validations";
import {
  useLazyGetSubscriptionQuery,
} from "../../service/subscription";
import { showError } from "../../constants/toasts";
import Loader from "../../constants/Loader";

export const ManageSubscription = () => {
  const navigate = useNavigate();
  const [getSubscription] = useLazyGetSubscriptionQuery();

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [subscription, setSubscription] = useState([]);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);

  const getSubscriptionApi = async () => {
    setLoading(true);
    try {
      const response = await getSubscription({
        search: debouncedSearchTerm.trim(),
        page,
      }).unwrap();
      setLoading(false);
      setHasFetched(true);
      if (response.status === 200) {
        setSubscription(response?.data?.items || []);
        setCount(response?.data?.totalCount);
      } else {
        setSubscription([]);
      }
    } catch (error: any) {
      setHasFetched(true);
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getSubscriptionApi();
  }, [page, debouncedSearchTerm]);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title d_flex">
        <div className="left_s">
          <h1 className="">Manage Subscription</h1>
        </div>

        <div className="right_s">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                placeholder="Search...."
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-subscription/add")}
          >
            + Add Subscription
          </Button>
          <FilterMenu
            startDate={null}
            endDate={null}
            setStartDate={() => { }}
            setEndDate={() => { }}
          />
        </div>
      </div>

      <div className="cards table_cards">
        <SubscriptionTable
          data={subscription}
          getSubscriptionApi={getSubscriptionApi}
          hasFetched={hasFetched}
        />
      </div>
      {subscription?.length ? (
        <CustomPagination
          currentPage={page - 1}
          totalPages={Math.ceil(count / 10)}
          count={count}
          pageSize={10}
          onPageChange={(page) => setPage(page + 1)}
        />
      ) : null}
    </MainContainer>
  );
};

export default ManageSubscription;
